module.exports = __webpack_public_path__ + "static/media/pid_lamp.8675a700.svg";